export default __webpack_public_path__ + "static/media/porcelain-pavers-patio.35c37878.jpg";